import { useMemo } from 'react';

import { getProgression } from 'bundles/degree-home/components/v3-dpm/lib/completionUtils';
import useCurriculum from 'bundles/degree-home/components/v3-dpm/lib/useCurriculum';
import type { ProgressionCalculatorResult } from 'bundles/degree-home/components/v3-dpm/types/gradeTypes';

const useProgressionCalculator = (): ProgressionCalculatorResult | null => {
  const curriculumGql = useCurriculum();

  const progression = useMemo(() => {
    if (!curriculumGql.data) {
      return null;
    }
    const curriculums = curriculumGql.data.Degree?.queryById?.curriculum?.curriculums || [];
    // The GPA Grade scale used to map grades to GPA points for the degree
    const gradeScale = curriculumGql.data?.Degree?.queryById?.gradeScale;
    if (!gradeScale) {
      return null;
    }
    return getProgression(curriculums, gradeScale);
  }, [curriculumGql.data]);
  return progression;
};

export default useProgressionCalculator;
